export const calculateOriginalAmount = (billingTotal) => (
    billingTotal.BookingBillingTotalReceipts - billingTotal.BookingBillingTotalRevenue
);

export default calculateOriginalAmount;
